export { default as TeamMemberBoxStyles } from './TeamMemberBox.module.scss';
export { default as TeamMemberHeadingStyles } from './TeamMemberHeading.module.scss';
export { default as TeamMemberListStyles } from './TeamMemberList.module.scss';
